// 2026-07-02 US-003
import { RootState } from 'store/rootTypes';

export const BulkNotificationsSelector = (state: RootState) => state.BulkNotifications;
